import { apiInstance } from '@diamond/shared/utils';

type ItemType = { index: number };

export const getBanners = async (token: string, selectedShipToId: string) => {
  const { data } = await apiInstance(token).get(`/banner`, {
    params: {
      warehouse: selectedShipToId,
    },
  });
  return data.sort((a: ItemType, b: ItemType) => {
    if (a.index > b.index) return 1;
    if (b.index > a.index) return -1;
    return 0;
  });
};
